<template>
  <div
    class="collapse-card"
    :class="{outline:outline,white:white,noBorderBottom:noBorderBottom,borderTop:borderTop,noBorderTop:noBorderTop}"
  >
    <div
      v-if="!isloading"
      class="collapse-card_content"
      :class="{outline:outline,white:white,'small-title':smallTitle,noPb:noPb}"
    >
      <div class="card-title">
        <p>
          {{ $t(cardTitle) }}
        </p>
        <a
          v-if="cardLink"
          :href="cardLink"
          target="_blank"
        >
          <i :class="trailingIcon" />
        </a>
        <p
          v-if="date"
          class="card-title_date"
        >
          {{ dateTitle }} <span class="date">{{ date }}</span>
        </p>
      </div>
      <div
        v-if="text"
        class="card-content"
      >
        <p
          ref="content"
          :class="{active:_active}"
        >
          {{ text }}
        </p>
      </div>
      <slot />
      <div
        v-if="hideContent && !hideCollapseBtn"
        class="collapse-btn"
      >
        <WsTextButton001
          v-if="active"
          leading-icon="icon-chevron-up"
          primary
          no-padding
          @click="collapseClose()"
        >
          {{ hideText }}
        </WsTextButton001>
        <WsTextButton001
          v-else
          leading-icon="icon-chevron-down"
          primary
          no-padding
          @click="collapseOpen()"
        >
          {{ showText }}
        </WsTextButton001>
      </div>
    </div>
    <div
      v-else
      class="collapse-card_isloading"
    >
      <SkeletonAnimate class="skekete title" />
      <div class="collapse-card_isloading-content">
        <SkeletonAnimate class=" skekete skekete1" />
        <SkeletonAnimate class=" skekete skekete1" />
        <SkeletonAnimate class=" skekete skekete2" />
        <SkeletonAnimate class=" skekete skekete1" />
        <SkeletonAnimate class=" skekete skekete2" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "CollapseCard",
  props: {
    collapseHeight: {
      type: Number,
      default: 96,
    },
    isloading: {
      type: Boolean,
      default: false,
    },
    outline: {
      type: Boolean,
      default: false,
    },
    leadingIcon: {
      type: String,
      default: "",
    },
    trailingIcon: {
      type: String,
      default: "",
    },
    cardContent: {
      type: String,
      default: "",
    },
    cardLink: {
      type: String,
      default: "",
    },
    cardTitle: {
      type: String,
      default: "",
    },
    white: {
      type: Boolean,
      default: false,
    },
    showText: {
      type: String,
      default() {
        return this.$t("展開");
      },
    },
    hideText: {
      type: String,
      default() {
        return this.$t("收起");
      },
    },
    noBorderBottom: {
      type: Boolean,
      default: false,
    },
    smallTitle: {
      type: Boolean,
      default: false,
    },
    borderTop: {
      type: Boolean,
      default: false,
    },
    date: {
      type: String,
      default: "",
    },
    dateTitle: {
      type: String,
      default: "",
    },
    noPb: {
      type: Boolean,
      default: false,
    },
    noBorderTop: {
      type: Boolean,
      default: false,
    },
    hideCollapseBtn: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    active: true,
    hideContent: false,
    text: "",
  }),
  computed: {
    _active() {
      if (this.hideCollapseBtn === false) {
        return this.active;
      } else {
        return true;
      }
    },
  },
  watch: {
    isloading() {
      this.$_init();
    },
  },
  mounted() {
    //fix 為什麼要用settimeout safari要用settimeout https://stackoverflow.com/questions/51922767/autofocus-input-on-mount-vue-ios
    this.$_init();
  },
  methods: {
    $_init() {
      this.text = this.cardContent;
      setTimeout(() => {
        if (this.$refs.content) {
          let contentHeight = this.$refs.content.getBoundingClientRect().height;
          const diff = contentHeight - this.collapseHeight
          if (contentHeight > this.collapseHeight && diff > 5) {
            this.hideContent = true;
            this.active = false;
          } else {
            this.hideContent = false;
          }
        }
      }, 0);
    },
    collapseToggle() {
      this.active = !this.active;
    },
    collapseOpen() {
      this.active = true;
    },
    collapseClose() {
      this.active = false;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/component/collapse-card";
</style>